var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-wrap"},[_c('iframe',{staticClass:"remote",attrs:{"src":_vm.remoteSrc,"allow":"clipboard-read; clipboard-write;"}})])}
var staticRenderFns = []

export { render, staticRenderFns }